export default function NotAvailable() {
    return (
        <>
            <section className="DataType">This Data Type Is Not Available Right Now</section>
        </>
    );
}